import { on_ready, is_elementor_edit } from 'js/utils';
import { hover_intent } from 'js/functions';
// import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';

import './internals.scss';

const is_mobile = window.innerWidth < 768 ;

on_ready(()=>{

    if( is_elementor_edit() ) return;

    //add_to_cart_ajax_init();

    // load_swiper_mobile();
    
    // add delay on hover out - to avoid instant close/off
    hover_intent_init();
    setTimeout(() => {
        toc_mobile_click();
    }, 1000); 
    
});

function hover_intent_init(){
    document.querySelectorAll('.hover_intent').forEach(el=>{
        const duration = el.dataset.duration || 300;
        hover_intent(el, duration);
    });
}

function toc_mobile_click(){ 

    
    if(!is_mobile) return;

    const toc = document.querySelector('.elementor-widget-table-of-contents');
    const toc_button = toc.querySelectorAll('.elementor-toc__list-item-text');
    const toc_toggle = toc.querySelector('.elementor-toc__toggle-button.elementor-toc__toggle-button--collapse');
     
    for(let i = 0; i < toc_button.length ; i++ ){
        toc_button[i].addEventListener('click', ()=>{ 
            toc_toggle.click();  
        });
    }
}
 